import { render, staticRenderFns } from "./DangerousButtons.vue?vue&type=template&id=f59443d2"
import script from "./DangerousButtons.vue?vue&type=script&lang=ts"
export * from "./DangerousButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports